module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_02_770_280_th-00260b6f0786343fe5a5483acb014437.jpg";